// extracted by mini-css-extract-plugin
module.exports = {"close-button":"close-button-1D2Y5RZUSOUfD1LA8QQlBZ","closeButton":"close-button-1D2Y5RZUSOUfD1LA8QQlBZ","x":"x-1giUT3yTdDqavWF7AH3jva"};